import { z } from 'zod';
import { durationSchema } from '../general/duration.ts';
import { mapStringToDurationOrOriginal } from '../general/helpers/duration.ts';

export const statsIntervalSchema = z
  .string()
  .trim()
  .nullable()
  .transform(/** Always transform the input, even if not focused */ mapStringToDurationOrOriginal)
  .pipe(durationSchema);

export const statsIntervalStrictSchema = z.custom<`${number}s`>((val): val is `${number}s` => {
  return typeof val === 'string' ? /^\d+s$/.test(val) : false;
});
